import { useSyncLocalStorage } from 'src/hooks/useSyncLocalStorage';

interface Params {
	localStorageKey: string;
}

export default function useCollapsibleState({ localStorageKey }: Params) {
	const [expanded, setExpanded] = useSyncLocalStorage(localStorageKey, false);

	const toggleExpanded = () => {
		setExpanded((prev) => !prev);
	};

	return [expanded, toggleExpanded] as const;
}
